import { useResponderEvents } from "@tamagui/react-native-use-responder-events";
import {
  Stack as WebStack,
  Text as WebText,
  composeEventHandlers,
  isRSC,
  mergeEvent,
  setupHooks
} from "@tamagui/web";
import { useElementLayout } from "./hooks/useElementLayout";
import { usePlatformMethods } from "./hooks/usePlatformMethods";
import { usePressability } from "./vendor/Pressability";
export * from "@tamagui/web";
const Stack = WebStack;
const Text = WebText;
setupHooks({
  getBaseViews() {
    const native = require("react-native");
    return {
      View: native.View || native.default.View,
      Text: native.Text || native.default.Text
    };
  },
  usePropsTransform(elementType, propsIn, hostRef) {
    const {
      // event props
      onMoveShouldSetResponder,
      onMoveShouldSetResponderCapture,
      onResponderEnd,
      onResponderGrant,
      onResponderMove,
      onResponderReject,
      onResponderRelease,
      onResponderStart,
      onResponderTerminate,
      onResponderTerminationRequest,
      onScrollShouldSetResponder,
      onScrollShouldSetResponderCapture,
      onSelectionChangeShouldSetResponder,
      onSelectionChangeShouldSetResponderCapture,
      onStartShouldSetResponder,
      onStartShouldSetResponderCapture,
      // android
      collapsable,
      focusable,
      // deprecated,
      accessible,
      accessibilityDisabled,
      onLayout,
      hrefAttrs,
      ...viewProps
    } = propsIn;
    if (!isRSC) {
      usePlatformMethods(hostRef);
      useElementLayout(hostRef, onLayout);
      useResponderEvents(hostRef, {
        onMoveShouldSetResponder,
        onMoveShouldSetResponderCapture,
        onResponderEnd,
        onResponderGrant,
        onResponderMove,
        onResponderReject,
        onResponderRelease,
        onResponderStart,
        onResponderTerminate,
        onResponderTerminationRequest,
        onScrollShouldSetResponder,
        onScrollShouldSetResponderCapture,
        onSelectionChangeShouldSetResponder,
        onSelectionChangeShouldSetResponderCapture,
        onStartShouldSetResponder,
        onStartShouldSetResponderCapture
      });
    }
    if (viewProps.href !== void 0 && hrefAttrs !== void 0) {
      const { download, rel, target } = hrefAttrs;
      if (download != null) {
        viewProps.download = download;
      }
      if (rel != null) {
        viewProps.rel = rel;
      }
      if (typeof target === "string") {
        viewProps.target = target.charAt(0) !== "_" ? `_${target}` : target;
      }
    }
    if (!viewProps.tabIndex) {
      const _focusable = focusable !== void 0 ? focusable : accessible;
      const role = viewProps.role;
      if (_focusable === false) {
        viewProps.tabIndex = "-1";
      }
      if (
        // These native elements are focusable by default
        elementType === "a" || elementType === "button" || elementType === "input" || elementType === "select" || elementType === "textarea"
      ) {
        if (_focusable === false || accessibilityDisabled === true) {
          viewProps.tabIndex = "-1";
        }
      } else if (
        // These roles are made focusable by default
        role === "button" || role === "checkbox" || role === "link" || role === "radio" || role === "textbox" || role === "switch"
      ) {
        if (_focusable !== false) {
          viewProps.tabIndex = "0";
        }
      }
      if (_focusable === true) {
        viewProps.tabIndex = "0";
      }
    }
    return viewProps;
  },
  useEvents(viewProps, events, { pseudos }, setStateShallow) {
    if (process.env.TAMAGUI_TARGET === "native") {
      const attachFocus = !!(pseudos == null ? void 0 : pseudos.focusStyle);
      if (attachFocus) {
        viewProps.onFocus = mergeEvent(viewProps.onFocus, () => {
          setStateShallow({ focus: true });
        });
        viewProps.onBlur = mergeEvent(viewProps.onBlur, () => {
          setStateShallow({ focus: false });
        });
      }
      const pressability = usePressability(
        events ? { ...events, hitSlop: viewProps.hitSlop } : {}
      );
      if (events == null ? void 0 : events.onPress) {
        for (const key in pressability) {
          const og = viewProps[key];
          const val = pressability[key];
          viewProps[key] = og && !dontComposePressabilityKeys[key] ? composeEventHandlers(og, val) : val;
        }
      }
    }
  }
});
const dontComposePressabilityKeys = {
  onClick: true
};
export {
  Stack,
  Text
};
//# sourceMappingURL=index.mjs.map
